import { render, staticRenderFns } from "./EligibilityJob.vue?vue&type=template&id=c18f1a76&scoped=true&"
import script from "./EligibilityJob.vue?vue&type=script&lang=js&"
export * from "./EligibilityJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18f1a76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
